<template>
  <div>
    <p>&nbsp;<br /><a v-show="!isExpanded" v-on:click.prevent="showForm" href="#" id="travel-agent-link" title="Click to enter travel agent IATA">Click here if you are a travel agent.</a></p>
    <div v-show="isExpanded" class="pepvalidate-v3 ajax-ignore full-width" id="travel-agent-form">
      <p class="full-width">Enter your IATA below.</p>
      <p class="full-width">
        <label>
          <span class="text">IATA</span>
          <input name="iata" type="text" :value="bookingLinkData.iata" @input="handleTextInput" />
        </label>
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import {mapState} from 'vuex';

export default defineComponent({
  name: "view-room-details-travel-agent-form",
  props: {},
  mounted: function () {},
  data: function () {
    return {
      isExpanded: false,
      formInitialized: false
    };
  },
  computed: {
    ...mapState([
        'bookingLinkData'
    ])
  },
  methods: {
    showForm: function () {
      if (!this.formInitialized) {
        const formNode: HTMLFormElement | null = this.$el.querySelector('.pepvalidate-v3');
        if (formNode && 'pepvalidateInitForm' in window) {
          window.pepvalidateInitForm.call(formNode);
          this.formInitialized = true;
        }
      }
      this.isExpanded = true;
      const inputNode: HTMLInputElement | null = this.$el.querySelector('[name=iata]');
      if (inputNode) {
        requestAnimationFrame(function () {
          inputNode.focus();
        });
      }
    },

    handleTextInput: function (event: Event) {
      this.bookingLinkData.iata =  (event.target as HTMLInputElement | null)?.value || '';
    }
  }
})
</script>

<style scoped>

</style>